import { Component, NgZone, OnDestroy, OnInit } from "@angular/core";
import { RegraFreteService } from "../../services/regra-frete.service";
import { AuthService } from "src/app/services/ajs-auth.service";
import { MatDialog, MatSnackBar } from "@angular/material";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { Router } from "@angular/router";

@Component({
  selector: "mandae-regra-frete-listar",
  templateUrl: "./listar.component.html",
  styleUrls: ["./listar.component.scss"],
})
export class ListarRegraFreteComponent implements OnInit, OnDestroy {
  public clienteId = 0;

  public currentCliente = [];

  public regras: any = [];

  public loading = false;

  constructor(
    public regraService: RegraFreteService,
    public authService: AuthService,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    private router: Router,
    private zone: NgZone
  ) {
    this.clienteId = this.authService.getCurrentUser()
      ? this.authService.getCurrentUser().id
      : 0;
  }

  public ngOnInit() {
    this.getToken();
  }

  public ngOnDestroy() {
    this.regras = [];
  }

  public async getToken() {
    try {
      this.loading = true;
      const data = await this.regraService.getToken();
      if (data.token) {
        localStorage.setItem("ls.token.app", JSON.stringify(data.token));
      }

      this.getRegras();
    } catch (error) {
      console.log(error);
    }
  }

  public async getRegras() {
    try {
      const data = await this.regraService.listarRegras();

      this.regras = data;
      this.determinarOrdem(data);
      this.loading = false;
    } catch (error) {
      console.log("error lista regras", error);
    }
  }

  public determinarOrdem(data) {
    const item = data;
    const ordem = [];

    item.map((el) => {
      ordem.push(el.id);
    });

    sessionStorage.setItem("mandae-regra-frete", JSON.stringify(ordem));
  }

  public async drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.regras, event.previousIndex, event.currentIndex);
    try {
      const ordem = [];
      this.regras.map((item) => {
        ordem.push(item.id);
      });

      await this.regraService.novaOrdem(ordem);
      await this.getRegras();
    } catch (error) {
      console.log("e", error);
    }
  }

  public responseEventEmitter(regra) {
    const ordem = JSON.parse(sessionStorage.getItem("mandae-regra-frete"));

    const index = ordem.indexOf(regra.id);

    if (regra.tipo === "nova-regra") {
      ordem.splice(index, 1);
      ordem.splice(index, 0, regra.novoId);
    }

    if (regra.tipo === "excluir-regra") {
      ordem.splice(index, 1);
    }

    this.definirNovaOrdem(ordem);
  }

  public async definirNovaOrdem(ordem) {
    try {
      this.loading = true;
      await this.regraService.novaOrdem(ordem);
      await this.getRegras();
    } catch (error) {
      console.log(error);
    }
  }

  public irPara() {
    const data = +new Date();
    this.zone.run(() =>
      this.router.navigate([
        `/configuracoes-do-usuario/regra-frete/criar/${data}`,
      ])
    );
  }
}
